import { render, staticRenderFns } from "./AfiliacionView.vue?vue&type=template&id=32ef711e&scoped=true&"
import script from "./AfiliacionView.vue?vue&type=script&lang=js&"
export * from "./AfiliacionView.vue?vue&type=script&lang=js&"
import style0 from "./AfiliacionView.vue?vue&type=style&index=0&id=32ef711e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef711e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VSelect,VTextarea})
